import { Eye, Pencil, Phone, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { CASES, CLIENTS } from "@/data/demo";
import { useAuth } from "@/lib/auth";
import { Avatar, Btn, Card, PageHeader } from "@/components/common";

const demo = () => toast("Demo mode — this action is visual only.");

export default function Clients() {
  const { user } = useAuth();
  const isLawyer = user.user_type === "lawyer";
  return (
    <div>
      <PageHeader title="Clients" subtitle={`${CLIENTS.length} clients`}>
        <Btn data-testid="add-client-button" variant="gold" onClick={demo}><Plus size={16} />Add Client</Btn>
      </PageHeader>
      <div data-testid="clients-list" className="grid gap-4 md:grid-cols-2">
        {CLIENTS.map((cl) => {
          const count = CASES.filter((c) => c.clientId === cl.id).length;
          return (
            <Card key={cl.id} data-testid={`client-card-${cl.id}`} className="p-5">
              <div className="flex items-center gap-4">
                <Avatar name={cl.name} />
                <div className="min-w-0 flex-1">
                  <div className="font-heading font-semibold text-navy">{cl.name}</div>
                  <div className="mt-0.5 flex items-center gap-1.5 text-sm text-slate-500"><Phone size={13} />{cl.phone}</div>
                </div>
                <span className="rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-800">{count} {count === 1 ? "case" : "cases"}</span>
              </div>
              <div className="mt-4 flex gap-2 border-t border-slate-100 pt-4">
                <Btn variant="outline" className="flex-1" data-testid={`client-view-${cl.id}`} onClick={demo}><Eye size={15} />View</Btn>
                <Btn variant="outline" className="flex-1" data-testid={`client-edit-${cl.id}`} onClick={demo}><Pencil size={15} />Edit</Btn>
                {isLawyer && <Btn variant="danger" className="flex-1" data-testid={`client-delete-${cl.id}`} onClick={demo}><Trash2 size={15} />Delete</Btn>}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
